import React from 'react';
import PropTypes from 'prop-types';
import {ALVA_SELECTED_ORGANIZATION_KEY} from './constants';
import {WithOrganization} from 'api/organizations/withOrganization';


export class WithSelectOrganization extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        onOrganizationSelected: PropTypes.func
    };

    static defaultProps = {
        onOrganizationSelected: () => undefined
    };

    selectOrganization = (organizationId, refetch, client) => {
        window.localStorage.setItem(ALVA_SELECTED_ORGANIZATION_KEY, organizationId);

        if (client && client.cache && client.cache.reset) {
            client.cache.reset().then(() => {
                this.props.onOrganizationSelected();
            });
        }
        else {
            this.props.onOrganizationSelected();
        }
    };

    render() {

        return (
            <WithOrganization renderIfLoading={true}>
                {({organization, refetch, client}) => {
                    const organizationId = organization ? organization.id : null;

                    return this.props.children({selectOrganization: (newId) => this.selectOrganization(newId, refetch, client), selectedOrganizationId: organizationId});
                }}
            </WithOrganization>
        );
    }
}
